import { useCallback, useState } from 'react'
import type { LegendPayload } from 'recharts/types/component/DefaultLegendContent'

/** Toggle series visibility by clicking legend items */
export const useLegendToggle = () => {
    const [hidden, setHidden] = useState<Set<string>>(new Set())

    const handleLegendClick = useCallback((data: LegendPayload) => {
        const key = String(data.dataKey ?? data.value ?? '')
        if (!key) return
        setHidden((prev) => {
            const next = new Set(prev)
            next.has(key) ? next.delete(key) : next.add(key)
            return next
        })
    }, [])

    const isHidden = useCallback((key: string) => hidden.has(key), [hidden])

    return { handleLegendClick, isHidden }
}
